import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, CURRENCY_NOTE } from './CtaButton';
import { trackCheckoutStart } from '../lib/metaPixel';

/**
 * Discreet mobile-only checkout bar. Appears once the hero CTA has scrolled
 * out of view and hides again whenever another CTA is on screen, so two
 * buttons never compete.
 */
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero-cta');
    const offer = document.getElementById('offer');
    if (!hero) return;
    const state = {
      heroVisible: true,
      offerVisible: false
    };
    const sync = () => setIsVisible(!state.heroVisible && !state.offerVisible);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) state.heroVisible = entry.isIntersecting;
        if (entry.target === offer) state.offerVisible = entry.isIntersecting;
      });
      sync();
    }, {
      rootMargin: '-8% 0px -8% 0px'
    });
    observer.observe(hero);
    if (offer) observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!isVisible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-brand-charcoal/10 bg-brand-ivory/95 px-4 pb-3 pt-2.5 backdrop-blur-sm transition-opacity duration-200 ease-out md:hidden ${isVisible ? 'opacity-100' : 'pointer-events-none opacity-0'}`} data-id="element-33" data-mp="24y8qx9h7p6o">
      <p className="mb-2 flex items-center justify-center gap-2 font-body text-[10px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-34" data-mp="lus7xweit6kx">
        <span className="font-bold text-brand-charcoal" data-id="element-35" data-mp="zti2b49ygs5l">23 USD</span>
        <span aria-hidden="true" className="text-brand-charcoal/25" data-id="element-36" data-mp="uvq5bvugefuj">
          ·
        </span>
        {CURRENCY_NOTE}
      </p>
      <a href={CHECKOUT_URL} tabIndex={isVisible ? 0 : -1} onClick={trackCheckoutStart} className="flex w-full items-center justify-center gap-2 rounded-[12px] bg-brand-terracotta px-5 py-3.5 font-body text-[13px] font-semibold uppercase tracking-[0.08em] text-brand-terracotta-text transition-colors duration-200 ease-out hover:bg-brand-terracotta-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-terracotta focus-visible:ring-offset-2" data-id="element-37" data-mp="31mzdghxaob53">
        Get Instant Access
        <span aria-hidden="true" className="text-base font-normal" data-id="element-38" data-mp="1ekrdbpzm52jo">
          →
        </span>
      </a>
    </div>;
}